export default {
	install: Vue => {
		Vue.filter('round', (numero, decimales) => {
			decimales = (typeof decimales !== 'number') ? 2 : decimales
			let absoluto = Math.round(numero * Math.pow(10, decimales))
			return absoluto / Math.pow(10, decimales)
		})
	}
}



// WEBPACK FOOTER //
// ./src/modulos/core/vue/libs/round.js